/*
 * @Author: xulihuan
 * @Date:   2018-03-29 14:51:21
 * @Last Modified by:   联想
 * @Last Modified time: 2018-04-17 19:47:44
 */
const QingsuIndex = resolve =>
  require(['../../../views/qingsu/QingsuIndex'], resolve)
const QingsuTeacherPage = resolve =>
  require(['../../../views/qingsu/QingsuTeacherPage'], resolve)
const QingsuCalling = resolve =>
  require(['../../../views/qingsu/QingsuCalling'], resolve)
const QingsuOrderDetail = resolve =>
  require(['../../../views/qingsu/QingsuOrderDetail'], resolve)
const QingsuHistory = resolve =>
  require(['../../../views/qingsu/QingsuHistory'], resolve)
const QingsuEvaluate = resolve =>
  require(['../../../views/qingsu/QingsuEvaluate'], resolve)
const QingsuOrderList = resolve =>
  require(['../../../views/qingsu/QingsuOrderList'], resolve)
const QingsuInsurance = resolve =>
  require(['../../../views/qingsu/QingsuInsurance'], resolve)
const QingsuInsuranceDetails = resolve =>
  require(['../../../views/qingsu/QingsuInsuranceDetails'], resolve)
const QingsuInsuranceList = resolve =>
  require(['../../../views/qingsu/QingsuInsuranceList'], resolve)
const QingsuInsuranceShare = resolve =>
  require(['../../../views/qingsu/QingsuInsuranceShare'], resolve)
const QingsuNewbie = resolve =>
  require(['../../../views/qingsu/QingsuNewbie'], resolve)
const QingsuOrderPage = resolve =>
  require(['../../../views/qingsu/QingsuOrderPage'], resolve)

export default [
  {
    path: '/qingsu-index',
    component: QingsuIndex,
    name: 'qingsuIndex',
    meta: {
      title: '倾诉首页'
    }
  },
  {
    path: '/qingsu-teacher-page',
    component: QingsuTeacherPage
  },
  {
    path: '/qingsu-customer-service',
    redirect: '/customer-service'
  },
  {
    path: '/qingsu-calling',
    component: QingsuCalling
  },
  {
    path: '/qingsu-order-detail',
    component: QingsuOrderDetail
  },
  {
    path: '/qingsu-history',
    component: QingsuHistory
  },
  {
    path: '/qingsu-evaluate',
    component: QingsuEvaluate
  },
  {
    path: '/qingsu-order-list',
    component: QingsuOrderList
  },
  {
    path: '/qingsu-insurance',
    component: QingsuInsurance,
    name: 'QingsuInsurance',
    meta: {
      title: '心情险首页'
    }
  },
  {
    path: '/qingsu-insurance-details',
    component: QingsuInsuranceDetails
  },
  {
    path: '/qingsu-insurance-list',
    component: QingsuInsuranceList
  },
  {
    path: '/qingsu-insurance-share',
    component: QingsuInsuranceShare
  },
  {
    path: '/qingsu-newbie',
    component: QingsuNewbie
  },
  {
    path: '/qingsu-order-page',
    component: QingsuOrderPage,
    meta: {
      pageName: '下单页',
      business: '倾诉'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/page/qingsu/index.js